// Whether an offboarded tenant can be reinstated yet, from what the
// operator surface says about it.
//
// The platform states the moment (`reinstatableAt`): only a tenant whose
// deletion has finished carries it, and a reinstatement before it is
// refused, because an attempt to delete the tenant's content may still be
// running until then. So the control is offered when the field is there,
// and pressable once the moment has passed — never by reading the status
// and guessing at the wait.

export type Reinstatement =
  /** Not offboarded, or its deletion has not finished: nothing to offer. */
  | { state: 'unavailable' }
  /** Offered, and not yet pressable; `in` is milliseconds until it is. */
  | { state: 'waiting'; from: Date; in: number }
  | { state: 'ready' }

export function reinstatement(tenant: { reinstatableAt?: string }, now: Date): Reinstatement {
  if (!tenant.reinstatableAt) return { state: 'unavailable' }
  const from = new Date(tenant.reinstatableAt)
  if (Number.isNaN(from.getTime())) return { state: 'unavailable' }
  const wait = from.getTime() - now.getTime()
  return wait > 0 ? { state: 'waiting', from, in: wait } : { state: 'ready' }
}
